export default "__VITE_ASSET__B3z2$Mmq__"